import CrudTab from 'react/containers/pages/CrudTab';

class Panel extends CrudTab {

  componentDidMount() {
    const { tab } = this.props;
    Monet.Session.Security.permissions.push({ authority: "PANEL_LIST", key: "PANEL_LIST" });
    try {
      const router = App.Objects.Panel = new App.Routers.Panel();
      router.showPanel(tab.extra.id, tab);
    } catch (error) {
      console.log(error);
    }
  }

  componentDidUpdate() {}
}

export default Panel;
